import React, { useContext, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import ArtworldContext from './../context/ArtworldContext'
import { recordClickHandler } from './../clickHandlers'

import uniqid from 'uniqid'
import { isEmpty } from 'lodash'

import { GetPosition, PolyPoints } from './../helpers'

// Leaflet
import L from 'leaflet'

import {
  Marker,
  Circle,
  Polygon,
  Polyline,
  Rectangle,
  Popup
} from 'react-leaflet'

const iconSettings = {
  iconSize: [25, 41],
  iconAnchor: [12.5, 41]
};

const active = {
  color: '#a51313',
  opacity: 0.7,
  weight: 1,
  fillColor: '#e85b5b',
  fillOpacity: 0.35
};

const inactive = {
  color: '#125b95',
  opacity: 0.7,
  weight: 1,
  fillColor: '#5492c3',
  fillOpacity: 0.35
};

const polyline = {
  weight: 3,
  color: '#ff0000'
};

// const activeIcon = new L.Icon({
//   iconUrl: require('./../assets/img/location-marker.png'),
//   iconRetinaUrl: require('./../assets/img/location-marker.png'),
//   ...iconSettings
// });

// const inactiveIcon = new L.Icon({
//   iconUrl: require('./../assets/img/location-marker.png'),
//   iconRetinaUrl: require('./../assets/img/location-marker.png'),
//   ...iconSettings
// });

const activeIcon = new L.Icon({
  iconUrl: require('./../assets/img/marker-icon-active.png'),
  iconRetinaUrl: require('./../assets/img/marker-icon-active.png'),
  ...iconSettings
});

const inactiveIcon = new L.Icon({
  iconUrl: require('./../assets/img/marker-icon.png'),
  iconRetinaUrl: require('./../assets/img/marker-icon.png'),
  ...iconSettings
});


const CreateMarker = props => {

  const context = useContext(ArtworldContext);

  const place_unique_key = 'places-' + props.result.place_id;

  const icon =
    context.activeRecordUniqueKey === place_unique_key
      ? activeIcon
      : inactiveIcon;

  const settings =
    context.activeRecordUniqueKey === place_unique_key
      ? active
      : inactive;

  const popup = <Popup>{props.result.title}</Popup>;

  const position = GetPosition(props.result)

  // Create unique key
  settings.key = props.result.type + '-' + props.result.place_id

  // onClick handling
  settings.onClick = () => props.onClickHandler({ position, result: props.result, place_unique_key, index: props.index })


  if (props.result.type === 'marker') {
    return (
      <Marker
        position={[position[0], position[1]]}
        icon={icon}
        // key={uniqid()}
        {...settings}
      >
        {popup}
      </Marker>
    );
  } else if (props.result.type === 'circle') {
    return (
      <Circle
        center={[position[0], position[1]]}
        radius={parseFloat(position[2])}
        key={uniqid()}
        {...settings}
      >
        {popup}
      </Circle>
    );
  } else if (props.result.type === 'polygon') {
    return (
      <Polygon
        // center={[center.x, center.y]}
        positions={PolyPoints(position)}
        key={uniqid()}
        {...settings}
      >
        {popup}
      </Polygon>
    );
  } else if (props.result.type === 'polyline') {
    return (
      <Polyline
        positions={PolyPoints(position)}
        key={uniqid()}
        {...settings}
        {...polyline}
      >
        {popup}
      </Polyline>
    );
  } else if (props.result.type === 'rectangle') {
    return (
      <Rectangle
        bounds={PolyPoints(position)}
        key={uniqid()}
        {...settings}
      >
        {popup}
      </Rectangle>
    );
  }

  return true
}


const MapMarkers = () => {
  const context = useContext(ArtworldContext);
  let navigate = useNavigate();

  const [markers, setMarkers] = useState('');

  const onClickHandler = props => {

    const record = {
      type: 'places',
      id: props.result.place_id,
      title: props.result.title
    }

    recordClickHandler({
      record: record,
      context: context,
      navigate: navigate,
      from: 'details > getRecord'
    })
  }

  useEffect(() => {
    if (!isEmpty(context.geoData)) {
      const markers = context.geoData.map((result, index) => {
        return <CreateMarker key={index} result={result} index={index} onClickHandler={onClickHandler} />
      })

      setMarkers(markers)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.geoData])

  return <div>{markers}</div>;
};

export default MapMarkers;
